<template>
	<div class="sa-flexbox">
		<div class="sa-flexbox-header">
			<div class="sa-flexbox-body-container">
				<b-row>
					<b-col v-for="headerElement in dashboard.headerElements" :key="headerElement.id" :cols="headerElement.cols" :xs="headerElement.xs" :sm="headerElement.sm" :md="headerElement.md" :lg="headerElement.lg" :xl="headerElement.xl">
						<data-analysis-dashboard-header-edit-component :view="true" :chartParams="headerElement" @updateChart="onUpdateChart"></data-analysis-dashboard-header-edit-component>
					</b-col>
				</b-row>
			</div>
		</div>
		<div class="sa-flexbox-body">
			<div class="sa-flexbox-body-container">
				<b-row>
					<b-col v-for="bodyElement in dashboard.bodyElements" :key="bodyElement.id" :cols="bodyElement.cols" :xs="bodyElement.xs" :sm="bodyElement.sm" :md="bodyElement.md" :lg="bodyElement.lg" :xl="bodyElement.xl">
						<data-analysis-chart-edit-component :view="true" :chartParams="bodyElement" @updateChart="onUpdateChart"></data-analysis-chart-edit-component>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
//import axios from "axios";
// import DataAnalysisChartViewComponent from "./DataAnalysisChartViewComponent.vue";
import DataAnalysisDashboardMixin from "../mixins/DataAnalysisDashboardMixin";
// import DataAnalysisDashboardHeaderViewComponent from "./DataAnalysisDashboardHeaderViewComponent.vue";
import DataAnalysisDashboardHeaderEditComponent from "./DataAnalysisDashboardHeaderEditComponent.vue";
import DataAnalysisChartEditComponent from "./DataAnalysisChartEditComponent.vue";
export default {
	props: {
		idDashboard: String,
	},
	mixins: [DataAnalysisDashboardMixin],
	components: { DataAnalysisChartEditComponent, DataAnalysisDashboardHeaderEditComponent },
	created() {
		if (this.idDashboard) {
			this.id = this.idDashboard;
		} else {
			this.id = this.$route.params.id;
		}
	},
	data() {
		return {
			id: null,
			pathResource: "/dataanalysisdashboard",
			jsonData: { title: "", descrizione: "", dashboard: { headerElements: [], bodyElements: [] } },
			dashboard: { headerElements: [], bodyElements: [] },
		};
	},
	mounted() {
		let me = this;
		//me.id = this.$route.params.id;
		if (me.id !== "-1") {
			me.loadData(); //<- sta in DataAnalysisDashboardMixin
		} else {
			me.jsonData.dashboard = JSON.stringify(this.dashboard);
			this.$emit("updateDashBoard", me.jsonData);
		}
	},
	methods: {
		onUpdateChart() {},
	},
};
</script>

<style></style>
